import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styles from './Select.less';

const {
	'select': selectClass,
	'select_fill': fillClass,
} = styles;

export default class Select extends Component {
	render() {
		const {options = [], className, fill, placeholder, ...props} = this.props;
		const classes = [selectClass];

		if (fill) {
			classes.push(fillClass);
		}

		if (className) {
			classes.push(className);
		}

		return (
			<select className={classes.join(' ')} {...props}>
				{placeholder ? <option value={''} disabled={true} defaultValue={true} hidden={true}>{placeholder}</option> : null}
				{options.map(({label, ...option}, idx) => (
					<option key={idx} {...option}>{label}</option>
				))}
			</select>
		);
	}
}

const TRUE_VALUE = '1';
const FALSE_VALUE = '0';

Select.propTypes = {
	options: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.any,
		value: PropTypes.any
	})).isRequired
};

export const getBooleanOptions = (true_label, false_label) => {
	return [{
		label: true_label || 'Да',
		value: TRUE_VALUE,
	},{
		label: false_label || 'Нет',
		value: FALSE_VALUE,
	},];
};

export const boolToValue = boolean_value => boolean_value ? TRUE_VALUE : FALSE_VALUE;

export const valueToBool = value => value === TRUE_VALUE;
